import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complianceService } from '../../services/complianceService';

export const useDismissAmlNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id =>
      complianceService.dismissNotification(id).then(response => {
        const { status, data } = response;
        if (status === 204) {
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.compliance.notifications],
          });
          return { data, success: true };
        }

        throw new Error(data?.message);
      }),
  });
};
